@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.destination-service {
  margin: 0;
  background-color: @settings-page--shipping-carriers-service-destination--background-color;
}
